var map = {
	"./bali.jpg": 1107,
	"./bangli.jpg": 9982,
	"./california.jpg": 1479,
	"./ijen.jpg": 8669,
	"./ikn.jpg": 2863,
	"./india.jpg": 6484,
	"./jakarta.jpg": 6787,
	"./japan.jpg": 7385,
	"./madrid.jpg": 3834,
	"./malaysia.jpg": 5984,
	"./paris.jpg": 7236,
	"./rinjani.jpg": 8422,
	"./singapore.jpg": 395,
	"./thailand.jpg": 6816,
	"./tibet.jpg": 6191,
	"./vietnam.jpg": 8889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2213;